export function formatNumber(n) {
  if (n === undefined || n === null) return "0";
  if (n >= 1_000_000) {
    return (n / 1_000_000).toFixed(1) + "m";
  } else if (n >= 1_000) {
    return (n / 1_000).toFixed(1) + "k";
  } else {
    return n.toFixed(0);
  }
}
